(function($, Drupal, once) {

  Drupal.behaviors.nasstar_calc_scripts = {
    attach: function (context, settings) {

      var currencySymbol = '&pound;'
      var maxValue = 1000000;

      function formatResult(result) {
        return result.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }

      function toInt(str) {
        if (str === null || str === undefined) {
          str = '';
        }

        return parseInt(str.replaceAll(',', ''));
      }

      function updateSectionThree() {
        var noOfResources = parseInt($('#noOfResources').val());
        var fulFilmentTime = parseInt($('#fulfilmentTime').val());
        var resourceTransactions = parseInt($('#resourceTransactions').val());
        var averagePrice = parseInt($('#averagePrice').val());

        var a = fulFilmentTime * averagePrice * noOfResources * resourceTransactions;
        var b = noOfResources * resourceTransactions * averagePrice * 1;

        var improveRevenuesBy = a - b;

        if (improveRevenuesBy < 0) {
          improveRevenuesBy = 0;
        }

        if (improveRevenuesBy > maxValue) {
          improveRevenuesBy = maxValue
        }

        $('#calc-section-3-result').html(formatResult(improveRevenuesBy));

        // Update values in webform
        $('input[name="calc_fulfilment_time"]').val(fulFilmentTime);
        $('input[name="calc_resource_transactions"]').val(resourceTransactions);
        $('input[name="calc_average_price"]').val(averagePrice);
        $('input[name="calc_revenue_result"]').val(improveRevenuesBy);
      }

      function updateSectionTwo() {
        var noOfResources = parseInt($('#noOfResources').val());
        var avgDailyResourceCost = parseInt($('#avgDailyResourceCost').val());
        var recruitmentCosts = parseInt($('#recruitmentCosts').val());
        var attrition = parseInt($('#attrition').val());
        var targetAttrition = parseInt($('#targetAttrition').val());
        var utilisationSaving = toInt($('#calc-section-1-result').html());

        var averageSalary = avgDailyResourceCost * 200;
        var averageRecruitmentFee = (averageSalary / 100) * recruitmentCosts;
        var annualAttrition = (noOfResources / 100) * attrition;
        var recruitmentFees = averageRecruitmentFee * annualAttrition;
        var recruitmentWithRetain = averageRecruitmentFee * targetAttrition;

        var reduceRecruitmentSourcingCostsBy = recruitmentFees - recruitmentWithRetain;
        var saving = utilisationSaving + reduceRecruitmentSourcingCostsBy;

        if (recruitmentCosts === 0 && attrition === 0 && targetAttrition === 0) {
          saving = 0;
        }

        if (saving < 0) {
          saving = 0;
        }

        if (saving > maxValue) {
          saving = maxValue
        }

        $('#calc-section-2-result').html(formatResult(saving));

        // Update values in webform
        $('input[name="calc_recruitment_costs"]').val(recruitmentCosts);
        $('input[name="calc_attrition"]').val(attrition);
        $('input[name="calc_target_attrition"]').val(targetAttrition);
        $('input[name="calc_sourcing_result"]').val(saving);
      }

      function updateSectionOne() {
        var noOfResources = parseInt($('#noOfResources').val());
        var avgDailyResourceCost = parseInt($('#avgDailyResourceCost').val());
        var currentUtilisation = parseInt($('#currentUtilisation').val());
        var increasedUtilisation = parseInt($('#increasedUtilisation').val());

        var annualBillingAt100Percent = (noOfResources * avgDailyResourceCost) * 220;
        var resultantAnnualRevenue = (annualBillingAt100Percent / 100) * currentUtilisation;
        var resultantAnnualRevenue2 = (annualBillingAt100Percent / 100) * increasedUtilisation;
        var resultantAnnualImprovement = Math.round(resultantAnnualRevenue2 - resultantAnnualRevenue);

        if (resultantAnnualImprovement < 0) {
          resultantAnnualImprovement = 0;
        }

        if (resultantAnnualImprovement > maxValue) {
          resultantAnnualImprovement = maxValue
        }

        $('#calc-section-1-result').html(formatResult(resultantAnnualImprovement));

        // Update values in webform
        $('input[name="calc_number_of_resources"]').val(noOfResources);
        $('input[name="calc_avg_daily_resource_cost"]').val(avgDailyResourceCost);
        $('input[name="calc_current_utilisation"]').val(currentUtilisation);
        $('input[name="calc_increased_utilisation"]').val(increasedUtilisation);
        $('input[name="calc_utilisation_result"]').val(resultantAnnualImprovement);
      }

      function updateResults() {
        updateSectionOne();
        updateSectionTwo();
        updateSectionThree();

        var sectionOneResult = toInt($('#calc-section-1-result').html());
        var sectionTwoResult = toInt($('#calc-section-2-result').html());
        var sectionThreeResult = toInt($('#calc-section-3-result').html());

        $('#totalSaving').html(formatResult(sectionOneResult + sectionTwoResult));
        $('#revenueIncrease').html(formatResult(sectionThreeResult));

        // Update values in webform
        if (sectionThreeResult > 0) {
          $('.revenue-increase-result').show();
        } else {
          $('.revenue-increase-result').hide();
        }
        $('input[name="calc_total_saving"]').val(sectionOneResult + sectionTwoResult);
        $('input[name="calc_total_revenue_increase"]').val(sectionThreeResult);
      }

      function skipSection3() {
        $('#fulfilmentTime').val(0).trigger('mousemove');
        $('#resourceTransactions').val(0).trigger('mousemove');
        $('#averagePrice').val(0).trigger('mousemove');
        $('#calc-section-3-result').html(formatResult(0));

        updateResults();

        $('#calc-section-3 a.btn').trigger('click');
      }

      function skipSection2() {
        $('#recruitmentCosts').val(0).trigger('mousemove');
        $('#attrition').val(0).trigger('mousemove');
        $('#targetAttrition').val(0).trigger('mousemove');
        $('#calc-section-2-result').html(formatResult(0));

        updateResults();

        $('#calc-section-2 a.btn').trigger('click');
      }

      $(document).ready(function(){
        if ($('.roi-calculator').length) {

          updateResults();

          var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
          var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new bootstrap.Tooltip(tooltipTriggerEl)
          });

          $('.skip-section-2').click(function(){
            skipSection2();
            return false;
          });

          $('.skip-section-3').click(function(){
            skipSection3();
            return false;
          });

          $('#currency').change(function(){
            currencySymbol = $(this).val();
            $('.dynamic-currency-symbol').html(currencySymbol);
          });

          $('.slider-container input').mousemove(function(){
            var value = $(this).val();
            var label = $(this).closest('.slider-container').find('.slider-value');

            label.html(value + '%');
            updateResults();
          });

          $('#calc-section-1 input, #calc-section-2 input, #calc-section-3 input').change(function(){
            updateResults();
          });

          $("#calc-section-1 a.btn").click(function() {
            $([document.documentElement, document.body]).animate({
              scrollTop: $("#calc-section-2").offset().top - 150
            }, 0);

            return false;
          });

          $("#calc-section-2 a.btn").click(function() {
            $([document.documentElement, document.body]).animate({
              scrollTop: $("#calc-section-3").offset().top - 150
            }, 0);

            return false;
          });

          $("#calc-section-3 a.btn").click(function() {
            $([document.documentElement, document.body]).animate({
              scrollTop: $("#roi-calculator-form").offset().top - 150
            }, 0);

            return false;
          });

          var headerHeight = $('header').height();
          var padding = 50;
          var total = headerHeight + padding;
          var threshold = $('.roi-calculator-container').offset().top - total;

          $(window).scroll(function(e){
            if ($(window).width() >= 1200) {
              var el = $('.roi-calculator-results');
              var scrollTop = $(this).scrollTop();
              var maxPadding = $('.roi-calculator-inner').innerHeight() - el.outerHeight() - padding;

              if (scrollTop >= threshold) {
                var topPadding = scrollTop - threshold;

                if (topPadding < maxPadding) {
                  el.css('marginTop', topPadding);
                  el.addClass('has-padding');
                }
              } else {
                if (el.hasClass('has-padding')) {
                  el.css('marginTop', 0);
                  el.removeClass('has-padding');
                }
              }
            }
          });

        }

      });
    }
  };


})(jQuery, Drupal, once)
